import widgetTemplate from './common-widget.html';

export default class CommonWidgetComponent {
  constructor() {
    this.transclude = {
      tooltip: '?widgetTooltip',
      header: '?widgetHeader',
      content: '?widgetContent',
      empty: '?widgetEmptyText',
    };

    this.bindings = {
      cssClass: '@',
      isEmpty: '<',
      isEditMode: '<',
      isDisabledShare: '<',
      isRemovable: '<',
      removeWidget: '&?',
      hideHeader: '<',
      showEmpty: '<',
      isMaintenance: '<',
      isLoading: '<?',
    };
    this.template = widgetTemplate;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/common/common-widget/common-widget-component.js